import React from 'react';
import { Box } from '@mui/material';

import { getFullName } from '@utils';

import { StageChip } from 'components/common/ui';
import theme from 'config/theme';

import {
  USER_STATUS_COLOR_MAP,
  USER_STATUSES_ENUM,
} from 'hooks/users/constants';

const UserDetailsSidebarStatus = ({ details }) => {
  const sideBarSubTitle = getFullName(details);

  const status = details?.status;
  const statusStr = USER_STATUSES_ENUM[status] || 'Unknown';

  const { color: statusColor, backgroundColor: statusBgColor } =
    USER_STATUS_COLOR_MAP[status] || USER_STATUS_COLOR_MAP.default;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box
        sx={{
          fontSize: '18px',
          fontWeight: 600,
          color: theme.palette.grays.gray700,
          flex: 1,
        }}
      >
        {sideBarSubTitle}
      </Box>
      <StageChip
        styles={{
          color: statusColor,
          backgroundColor: statusBgColor,
          fontSize: '12px',
          fontWeight: 400,
        }}
      >
        {statusStr}
      </StageChip>
    </Box>
  );
};

export default UserDetailsSidebarStatus;
